export default __webpack_public_path__ + "static/media/img3.ad122e36.jpg";